import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule, ScreenTrackingService } from '@angular/fire/analytics';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule, BUCKET } from '@angular/fire/storage';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule, MatGridTile } from '@angular/material/grid-list';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LightboxModule } from 'ngx-lightbox';
import { MomentModule } from 'ngx-moment';
import { Nl2BrPipeModule } from 'nl2br-pipe';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContactComponent } from './contact/contact.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { MapComponent } from './map/map.component';
import { MarketComponent, MarketStandDialog } from './market/market.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ShopDetailsComponent } from './shop-details/shop-details.component';
import { ShopService } from './shop.service';
import { CovidPartnersComponent } from './covid-partners/covid-partners.component';
import { HappyDaysComponent } from './happy-days/happy-days.component';
import { BraderieComponent } from './braderie/braderie.component';
import { HalloweenComponent } from './halloween/halloween.component';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    MapComponent,
    ShopDetailsComponent,
    MainNavComponent,
    MarketComponent,
    MarketStandDialog,
    ContactComponent,
    HalloweenComponent,
    HappyDaysComponent,
    BraderieComponent,
    CovidPartnersComponent
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    MomentModule,
    BrowserAnimationsModule,
    GoogleMapsModule,
    Nl2BrPipeModule,
    LightboxModule,
    MatCardModule, MatIconModule, MatProgressSpinnerModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatNativeDateModule, MatSidenavModule,
    MatButtonModule, MatDividerModule, MatListModule, MatToolbarModule, LayoutModule, MatGridListModule, MatDialogModule, MatSnackBarModule,
    MatGridListModule,
  ],
  providers: [ShopService, { provide: BUCKET, useValue: 'acal-levallois.appspot.com' }, ScreenTrackingService],
  bootstrap: [AppComponent],
  entryComponents: [HappyDaysComponent, BraderieComponent, ContactComponent, HalloweenComponent, MarketStandDialog]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg')); // Or whatever path you placed mdi.svg at
  }
}
